import {SimpleObjectPool} from "./SimpleObjectPool";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {DasUBoot} from "../DasUBoot";
import {GlowFrame} from "../reels/symbols/symbolparts/GlowFrame";


/**
 * Created by jonas on 2020-08-14.
 */

export class GraphicsPool {
    private spinePoolMap:Map<string, SimpleObjectPool<PIXI.spine.Spine>>;
    private spritePoolMap:Map<string, SimpleObjectPool<PIXI.Sprite>>;
    private genericPool:Map<string, SimpleObjectPool<any>>;

    public static SYMBOL_FRAME:string = "symbolFrame";

    constructor() {
        this.spinePoolMap = new Map();
        this.spritePoolMap = new Map();

        this.genericPool = new Map();

        this.addSpinePool(DasUBootGameAssets.SYMBOL_EXPLOSION_SPINE, 8, 1, 22);
        this.addSpinePool(DasUBootGameAssets.BOMB_SYMBOL_SPINE, 4, 1, 22);
        this.addSpinePool(DasUBootGameAssets.BOMB_SYMBOL_EXPLOSION_SPINE, 2, 1, 5);
        this.addSpinePool(DasUBootGameAssets.SCATTER_SYMBOL_SPINE, 4, 1, 5);
        this.addSpinePool(DasUBootGameAssets.PERISCOPE_SYMBOL_SPINE, 4, 1, 5);
        this.addSpinePool(DasUBootGameAssets.STACKED_WILD_SPINE, 2, 1, 2);

        this.addSpinePool(DasUBootGameAssets.SMALL_EXPLOSION, 3, 1, 10);


        this.addPool(this.genericPool, ()=>this.winFrameFactory(), GraphicsPool.SYMBOL_FRAME, 25,1); //.setLogLevel(LogLevel.INFO,true, true);
    }



    protected winFrameFactory():PIXI.Container {
        const frameSprite = new PIXI.NineSlicePlane(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_FRAME)[0], 32,32,32,32);
        const dotSprites:PIXI.Sprite[] = [
            new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_DOT)[0])
        ]

        const sweepSprite = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SYMBOL_GLOW_SONAR_SWEEP)[0])

        const frame = new GlowFrame(frameSprite, dotSprites, sweepSprite);
        frame.spread.set(16, 16);
        frame.frameSize.set(144, 144);
        frame.pivot.set(66, 90);
        frame.position.set(66, 90);

        return frame;
    }




    //-------------- SPINE
    public static spineFactory(name:string):PIXI.spine.Spine {
        const spine = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(name));
        spine.update(0);
        return spine;
    }

    public addSpinePool(poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<PIXI.spine.Spine> {
        return this.addPool(this.spinePoolMap, (name:string) => GraphicsPool.spineFactory(name), poolName, startSize, growRate, maxSize, assetName);
    }

    public getSpinePool(name:string):SimpleObjectPool<PIXI.spine.Spine> {
        return this.getPool(name, this.spinePoolMap);
    }


    //-------------- SPRITE
    private spriteFactory(name:string):PIXI.Sprite {
        return new PIXI.Sprite(DasUBoot.assetLoader.getTextures(name)[0]);
    }

    public addSpritePool(poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<PIXI.Sprite> {
        return this.addPool(this.spritePoolMap, (name:string) => this.spriteFactory(name), poolName, startSize, growRate, maxSize, assetName);
    }

    public getSpritePool(name:string):SimpleObjectPool<PIXI.Sprite> {
        return this.getPool(name, this.spritePoolMap);
    }


    public getGenericPool(name:string):SimpleObjectPool<any> {
        return this.getPool(name, this.genericPool);
    }



    //-------------- GENERIC
    private addPool(map:Map<any, any>, factory:(name:string) => any, poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<any> {
        if (map.has(poolName)) {
            throw new Error("Pool already exist with name: " + poolName);
        }

        const asset = assetName == undefined ? poolName : assetName;
        const pool = new SimpleObjectPool<any>(
            poolName,
            () => {
                return factory(asset)
            },
            startSize,
            growRate,
            maxSize
        );


        map.set(poolName, pool);
        return pool;
    }

    private getPool(name:string, map:Map<any, any>):SimpleObjectPool<any> {
        const pool = map.get(name);
        if (pool == undefined) {
            throw new Error(`Cant find pool named:  ${name}`);
        }
        return pool;
    }



}